/* unplugin-vue-components disabled */import { render } from "./license.vue?vue&type=template&id=188e59c8&scoped=true"
import script from "./license.vue?vue&type=script&lang=js"
export * from "./license.vue?vue&type=script&lang=js"

import "./license.vue?vue&type=style&index=0&id=188e59c8&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188e59c8"]])

export default __exports__